import React, { useEffect, useState } from "react";
import { Col, Form, Modal, Row } from "react-bootstrap";
import SbCancelBtn, { SBSaveUpdateBtn } from "../../Buttons/Buttons";
import Select from 'react-select';
import { postStorageTypeMasterDatas } from "../../../redux/action";
import * as HeaderAuthentication from '../../HeaderAuthentication'
import { ADDED_BY_ID } from "../../../Constants";
import { useDispatch } from "react-redux";

const statusOptions = [
    { value: 79, label: "Active" },
    { value: 80, label: "Inactive" }
]

const AddStorageTypeMaster = (props) => {

    const signInDetails = JSON.parse(sessionStorage.getItem('SignInDetails'));
    const storedCompanyID = signInDetails ? signInDetails[0].CompanyID : null;
    let dispatch = useDispatch();

    const [storageTypeMasterData, setStorageTypeMasterData] = useState({
        StorageTypeCode: "",
        StorageTypeDescription: "",
        CompanyID: storedCompanyID,
        AddedByID: ADDED_BY_ID,
        StatusID: null
    });

    const [errors, setErrors] = useState({
        StorageTypeCode: "",
        StorageTypeDescription: ""
    });

    useEffect(() => {
        if (props.storageTypeID && props.getSingleStorageTypeMasterData?.length > 0) {
            const storageTypeData = props.getSingleStorageTypeMasterData[0];
            setStorageTypeMasterData({
                StorageTypeID: props.storageTypeID,
                StorageTypeCode: storageTypeData.StorageTypeCode || "",
                StorageTypeDescription: storageTypeData.StorageTypeDescription || "",
                CompanyID: storageTypeData.CompanyID,
                AddedByID: ADDED_BY_ID,
                StatusID: storageTypeData.StatusID || null
            });
        }
    }, [props.storageTypeID, props.getSingleStorageTypeMasterData]);

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setStorageTypeMasterData((prevData) => ({
            ...prevData,
            [name]: value,
        }));
        setErrors((prevErrors) => ({
            ...prevErrors,
            [name]: "" // Clear error on typing
        }));
    };

    const handleStatusChange = (selectedOption) => {
        setStorageTypeMasterData((prevData) => ({
            ...prevData,
            StatusID: selectedOption ? selectedOption.value : null
        }));
    };

    const validateForm = () => {
        const newErrors = {};
        if (!storageTypeMasterData.StorageTypeCode.trim()) {
            newErrors.StorageTypeCode = "required !";
        }
        if (!storageTypeMasterData.StorageTypeDescription.trim()) {
            newErrors.StorageTypeDescription = "required !";
        }
        setErrors(newErrors);
        return Object.keys(newErrors).length === 0;
    };

    const AddStorageTypeMasterData = (e) => {
        e.preventDefault();
        if (validateForm()) {
            const requestOption = {
                method: "POST",
                mode: "cors",
                headers: HeaderAuthentication.postExcomatixAuth,
                body: JSON.stringify(storageTypeMasterData),
            };
            dispatch(postStorageTypeMasterDatas(requestOption, props.handleCloseModal, props.storageTypeID, props.storageMasterData));
            console.log(storageTypeMasterData, 'storageTypeMasterData');
        }
    };

    return (
        <>
            <Modal show={props.open} onHide={props.handleCloseModal} className=' add-role-modal'>
                <Modal.Header closeButton>
                    <Modal.Title>{props.storageTypeID ? "Edit Storage Type Master" : "Add Storage Type Master"}</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Row className='customer-form-fields'>
                        <Col>
                            <Row>
                                <Col md={12}>
                                    <div>
                                        <label className="pb-1 pt-1">Code <span className="required-asterisk">*</span></label>
                                        <Form.Control
                                            type="text"
                                            name="StorageTypeCode"
                                            value={storageTypeMasterData.StorageTypeCode}
                                            onChange={handleInputChange}
                                        />
                                        {errors.StorageTypeCode && <div className="text-danger">{errors.StorageTypeCode}</div>}
                                    </div>
                                </Col>
                            </Row>
                            <Row>
                                <Col md={12}>
                                    <div>
                                        <label className="pb-1 pt-1">Description <span className="required-asterisk">*</span></label>
                                        <Form.Control
                                            as="textarea"
                                            rows={2}
                                            name="StorageTypeDescription"
                                            value={storageTypeMasterData.StorageTypeDescription}
                                            onChange={handleInputChange}
                                        />
                                        {errors.StorageTypeDescription && <div className="text-danger">{errors.StorageTypeDescription}</div>}
                                    </div>
                                </Col>
                                {props.storageTypeID && <Col md={4}>
                                    <div>
                                        <label>Status</label>
                                        <Select
                                            className="react-select-container"
                                            classNamePrefix="react-select"
                                            options={statusOptions}
                                            placeholder="Select"
                                            value={statusOptions.find(option => option.value === storageTypeMasterData.StatusID) || null}
                                            onChange={handleStatusChange}
                                            menuPosition="fixed"
                                            menuShouldScrollIntoView={false}
                                        />
                                    </div>
                                </Col>}
                            </Row>
                        </Col>
                    </Row>
                </Modal.Body>
                <Modal.Footer>
                    <SbCancelBtn btnName="Cancel" onClickEffect={props.handleCloseModal} />
                    <SBSaveUpdateBtn btnName="Submit" onClickEffect={AddStorageTypeMasterData} />
                </Modal.Footer>
            </Modal>
        </>
    );
}

export default AddStorageTypeMaster;
